export default __webpack_public_path__ + "static/PlayfairDisplay-Italic-8e8485b35b6efcd552a2d1cd046675a1.woff2";